/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  /* op-collection-filter-exclusions ----------------------------------------
   * Hides specific filter values on specific collection pages.
   * To exclude more values, add an entry to EXCLUSIONS below:
   *   '<collection-handle>': { '<filter-param-name>': ['Value 1', 'Value 2'] }
   * Filter param names look like 'filter.p.m.custom.<key>' for product
   * metafields, or 'filter.v.option.<name>' for variant options.
   * Hide is visual only; direct URL-with-filter still works.
   * ------------------------------------------------------------------------ */
  var EXCLUSIONS = {
    'unisex': {
      'filter.p.m.custom.category': ['Unisex', "Women's"]
    },
    'women': {
      'filter.p.m.custom.category': ['Unisex', "Women's"]
    },
    'kids': {
      'filter.p.m.custom.category': ["Women's", 'Kids']
    },
    'fitted': {
      'filter.p.m.custom.category': ["Women's"]
    },
    'towel': {
      'filter.p.m.custom.category': ['Towel']
    },
    'denim-1': {
      'filter.p.m.custom.category': ['Denim']
    },
    'denim': {
      'filter.p.m.custom.category': ['Denim']
    }
  };

  function getCollectionHandle() {
    var m = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    // Fallback for very old browsers: escape characters that have meaning in selectors
    return String(value).replace(/([\\"'\[\]:.#()\s])/g, '\\$1');
  }

  function applyExclusions() {
    var handle = getCollectionHandle();
    if (!handle || !EXCLUSIONS[handle]) return;
    var rules = EXCLUSIONS[handle];
    Object.keys(rules).forEach(function(paramName) {
      rules[paramName].forEach(function(value) {
        var selector = 'input[name="' + cssEscape(paramName) + '"][value="' + cssEscape(value) + '"]';
        document.querySelectorAll(selector).forEach(function(input) {
          var li = input.closest('li');
          if (li && li.style.display !== 'none') li.style.display = 'none';
        });
      });
    });
  }

  function initFilterExclusions() {
    applyExclusions();
    var target = document.getElementById('MainContent') || document.body;
    if (!target || !window.MutationObserver) return;
    var debounceTimer = null;
    var observer = new MutationObserver(function() {
      if (debounceTimer) return;
      debounceTimer = setTimeout(function() {
        debounceTimer = null;
        applyExclusions();
      }, 50);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterExclusions);
  } else {
    initFilterExclusions();
  }


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


/* op-coming-soon ------------------------------------------------------------
   Relabels sold-out UI as "Coming Soon" for products tagged 'coming-soon'
   (handle list emitted by snippets/custom-coming-soon.liquid via the
   'coming-soon' smart collection). Only rewrites labels Broadcast already
   renders for unavailable products, so it self-expires when stock arrives.
   Covers: PDP buy button + sticky cart bar, grid/search card badge + price
   label, quick-view modal; re-applies after variant changes and AJAX
   re-renders (MutationObserver). Fully isolated: no Broadcast JS calls. */
(function () {
  var LABEL = 'Coming Soon';

  function handles() { return window.opComingSoonHandles || []; }

  function handleFromUrl(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function cardHandle(card) {
    var h = handleFromUrl(card.getAttribute('data-url'));
    if (h) return h;
    var link = card.querySelector('a[href*="/products/"]');
    return link ? handleFromUrl(link.getAttribute('href')) : null;
  }

  function setFirstText(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        if (n.nodeValue.trim() !== LABEL) n.nodeValue = LABEL;
        return;
      }
    }
    if (el.textContent.trim() !== LABEL) el.textContent = LABEL;
  }

  // Two-tier badge: "Coming Soon" + a sign-up nudge, with a shorter mobile
  // variant (CSS picks one). Idempotent — skips elements already rewritten.
  var SUB_DESKTOP = 'Sign up to be first';
  var SUB_MOBILE = 'Get notified';
  function setBadge(el) {
    if (el.classList.contains('op-cs-badge')) return;
    el.classList.add('op-cs-badge');
    el.textContent = '';
    var main = document.createElement('span'); main.className = 'op-cs-badge__main'; main.textContent = LABEL;
    var subD = document.createElement('span'); subD.className = 'op-cs-badge__sub op-cs-badge__sub--desktop'; subD.textContent = SUB_DESKTOP;
    var subM = document.createElement('span'); subM.className = 'op-cs-badge__sub op-cs-badge__sub--mobile'; subM.textContent = SUB_MOBILE;
    el.appendChild(main); el.appendChild(subD); el.appendChild(subM);
  }

  function apply() {
    var list = handles();
    if (!list.length) return;

    // Product cards (collection grid, search, related, predictive search):
    // "Sold Out" badge and the sold-out price replacement.
    document.querySelectorAll('.badge-box.sold-box, span.sold-out').forEach(function (el) {
      var card = el.closest('[data-grid-item], .product-item');
      if (!card) return;
      var h = cardHandle(card);
      if (!h || list.indexOf(h) === -1) return;
      // Grid badge gets a two-tier layout (label + sign-up nudge); price span stays plain text.
      if (el.classList.contains('badge-box')) setBadge(el); else setFirstText(el);
    });

    // PDP + sticky cart bar: disabled add-to-cart button only, so normal
    // behavior returns untouched the moment a variant is purchasable.
    document.querySelectorAll('product-info[data-product-handle]').forEach(function (pi) {
      if (list.indexOf(pi.getAttribute('data-product-handle')) === -1) return;
      pi.querySelectorAll('button[name="add"][disabled] [data-add-to-cart-text]').forEach(setFirstText);
      // Sticky cart bar for the same product: when nothing is buyable its
      // label span drops data-add-to-cart-text, so key off the sold-out
      // wrapper state classes + .btn__text instead. Both disappear once a
      // variant is purchasable, so this self-expires too.
      document.querySelectorAll('cart-bar .variant--soldout .btn__text, cart-bar .all-variants--soldout .btn__text').forEach(setFirstText);
    });

    // Quick-view modal (fetched async; derive handle from links inside it).
    document.querySelectorAll('[data-product-upsell-ajax]').forEach(function (modal) {
      var link = modal.querySelector('a[href*="/products/"]');
      var h = link && handleFromUrl(link.getAttribute('href'));
      if (!h || list.indexOf(h) === -1) return;
      modal.querySelectorAll('button[name="add"][disabled] [data-add-to-cart-text]').forEach(setFirstText);
    });
  }

  function init() {
    if (!handles().length) return;
    apply();
    if (!window.MutationObserver) return;
    var debounceTimer = null;
    new MutationObserver(function () {
      if (debounceTimer) return;
      debounceTimer = setTimeout(function () {
        debounceTimer = null;
        apply();
      }, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* op-card-video --------------------------------------------------------------
   Plays product-card videos (snippets/custom-card-video.liquid) only while they
   are on screen. The <video> carries no autoplay attribute and preload="none",
   so nothing downloads until IntersectionObserver says it is visible; leaving
   the viewport pauses it. Honors prefers-reduced-motion and Save-Data (poster
   only). Re-scans after AJAX grid re-renders. Fully isolated: no Broadcast JS. */
(function () {
  var SEL = 'video[data-op-card-video]';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.2 });

  function scan() {
    document.querySelectorAll(SEL).forEach(function (v) {
      if (v.dataset.opObserved) return;
      v.dataset.opObserved = '1';
      io.observe(v);
    });
  }

  function init() {
    scan();
    if (!window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; scan(); }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();


  /* op-exact-search ----------------------------------------------------------
   * Shopify's built-in "semantic" search (mandatory since March 2025) turns a
   * search for CRYSTAL into 177 results, most of them unrelated. Shopify's own
   * docs: semantic understanding and typo tolerance are switched OFF when the
   * query uses search syntax, and a word in double quotes means an exact match
   * in title or description. So we quote every word the shopper types before
   * the form submits: crystal -> "crystal", navy puppy -> "navy" "puppy"
   * (terms are ANDed). Power users who already type syntax (quotes, title:,
   * -word, OR) are left alone. On the results page the quotes are hidden from
   * the caption, the search box and the tab title, and when an exact search
   * finds nothing we offer a one-click "broader search" (the unquoted query).
   * Isolation: hooks the native form submit + link clicks at document level,
   * targets [data-*] attributes only, no Broadcast JS/CSS dependency.
   * To switch off: set OP_EXACT_SEARCH to false.
   * AUTHOR: Claude   DATE: 2026-10-30   BUILD: 2 (re-push to bust a stale CDN copy)
   * DEPENDS ON: None — native form submit + Shopify search syntax only.
   *   Attributes used: [data-results-count], [data-products-grid] (Broadcast
   *   data hooks; if they vanish the quotes simply stay visible, nothing breaks).
   * ------------------------------------------------------------------------ */
  var OP_EXACT_SEARCH = true;

  function opIsSearchPath(pathname) {
    return /\/search\/?$/.test(pathname || '');
  }

  function opHasSyntax(q) {
    return /["]/.test(q) || /(^|\s)-\S/.test(q) || /\b[a-z_.]+:\S/i.test(q) || /\s(OR|AND|NOT)\s/.test(q);
  }

  function opQuoteQuery(q) {
    var s = (q || '').trim().replace(/\s+/g, ' ');
    if (!s || opHasSyntax(s)) return q;
    return s.split(' ').map(function (w) { return '"' + w + '"'; }).join(' ');
  }

  function opUnquoteQuery(q) {
    return (q || '').replace(/"/g, '');
  }

  function opIsAutoQuoted(q) {
    // Every token wrapped in quotes and nothing else = produced by opQuoteQuery
    var s = (q || '').trim();
    return s.length > 0 && /^"[^"]+"(\s+"[^"]+")*$/.test(s);
  }

  if (OP_EXACT_SEARCH) {
    // 1. Any search form on the site (header popdown, search page, 404, etc.)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (!opIsSearchPath(action.split('?')[0])) return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      input.value = opQuoteQuery(input.value);
    }, true);

    // 2. Links to the search page (predictive "search for X", query suggestions)
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.origin); } catch (err) { return; }
      if (url.origin !== window.location.origin || !opIsSearchPath(url.pathname)) return;
      var q = url.searchParams.get('q');
      if (!q) return;
      var quoted = opQuoteQuery(q);
      if (quoted === q) return;
      url.searchParams.set('q', quoted);
      a.setAttribute('href', url.pathname + url.search + url.hash);
    }, true);

    // 3. Results page: hide the quotes from the shopper
    var opSearchQ = null;
    try { opSearchQ = new URL(window.location.href).searchParams.get('q'); } catch (err) {}
    if (opIsSearchPath(window.location.pathname) && opSearchQ && opIsAutoQuoted(opSearchQ)) {
      var opPlain = opUnquoteQuery(opSearchQ);

      var opCleanSearchPage = function () {
        document.querySelectorAll('input[type="search"]').forEach(function (inp) {
          if (inp.value === opSearchQ) inp.value = opPlain;
        });
        // The theme wraps the terms in its own quotes, so the raw text reads
        // ""crystal"". We only ever collapse that wrapped form to "crystal" —
        // idempotent, so it is safe to re-run after every AJAX sort/filter
        // re-render (which swaps the raw text back into the same element).
        var wrapped = '"' + opSearchQ + '"';
        var clean = '"' + opPlain + '"';
        var nodes = document.querySelectorAll('[data-results-count], p, h1, h2, h3');
        nodes.forEach(function (el) {
          if (el.children.length) return;
          if (el.textContent.indexOf(wrapped) === -1) return;
          el.textContent = el.textContent.split(wrapped).join(clean);
        });
        if (document.title.indexOf(wrapped) !== -1) {
          document.title = document.title.split(wrapped).join(clean);
        }

        // Exact search found nothing (typo, singular/plural, partial word):
        // fall back automatically to Shopify's broad search for the same words.
        // op_broad=1 marks the URL so this never loops.
        var grid = document.querySelector('[data-products-grid]');
        var hasProducts = grid && grid.querySelector('a[href*="/products/"]');
        var broadUrl = new URL(window.location.href);
        if (grid && !hasProducts && broadUrl.searchParams.get('op_broad') !== '1' && !window.opBroadRedirect) {
          window.opBroadRedirect = true;
          broadUrl.searchParams.set('q', opPlain);
          broadUrl.searchParams.set('op_broad', '1');
          window.location.replace(broadUrl.pathname + broadUrl.search);
        }
      };

      opCleanSearchPage();
      // Filters/sort re-render via AJAX (text swapped in place or whole section
      // replaced); watch the body so the cleanup always re-runs. It is cheap.
      new MutationObserver(function () { opCleanSearchPage(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    // Fallback page (op_broad=1): say why the shopper sees broad results
    var opBroadQ = null;
    try { var opU = new URL(window.location.href); if (opU.searchParams.get('op_broad') === '1') opBroadQ = opU.searchParams.get('q'); } catch (err) {}
    if (opIsSearchPath(window.location.pathname) && opBroadQ) {
      var opAddBroadNote = function () {
        var grid = document.querySelector('[data-products-grid]');
        if (!grid || document.querySelector('.op-search-note')) return;
        var note = document.createElement('p');
        note.className = 'op-search-note';
        note.style.cssText = 'text-align:center;margin:0 16px 24px;opacity:.7;';
        note.textContent = 'No exact match for \u201c' + opBroadQ + '\u201d \u2014 showing the closest results.';
        grid.parentNode.insertBefore(note, grid);
      };
      opAddBroadNote();
      new MutationObserver(function () { opAddBroadNote(); }).observe(document.body, { childList: true, subtree: true });
    }
  }


})();
